import { AGENT_STATE } from "../../../constants/reducer_names";
import { FailedUserFetchResponse } from "../../../constants/error_messages";
import { createSlice } from "@reduxjs/toolkit";
import { updateAgentState } from "../../api/agent_status";

const initialState = {
  loading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  status: [] as any,
  currentStatus: {} as any,
  agentStatus: [] as any
};

const agentState = createSlice({
  name: AGENT_STATE,
  initialState,
  reducers: {
    addStatusList: (state, { payload }) => {
      state.status = payload;
    },
    setCurrentStatus: (state, { payload }) => {
      const index = state.status?.findIndex((element: any) => element?.statusName === payload.status);
      if (index !== -1) {
        state.currentStatus = state.status[index];
      }
    },
    setAgentStatus: (state, { payload }) => {
      state.agentStatus = payload
    },
    reset: () => { },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAgentState.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateAgentState.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.status = payload?.data?.getAgentListRes;
        state.agentStatus = payload?.data?.getAgentListRes;
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.loading = false;
    });
    builder.addCase(updateAgentState.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      state.loading = false;
    });
  },
});

export const AgentStateAction = agentState.actions;
export default agentState.reducer;
